import { IRack, RACK_SECTION_TYPE3 } from "@mobx/store/locations/types";

const rackMiners = (r: IRack) => r.rack_items.filter(it => it.pos === RACK_SECTION_TYPE3.MINER).map(it => ({...it}));

export default rackMiners;